import { useContext } from "react";
import { GoOfflineContext } from "./context";

export function useGoOffline() {
  const value = useContext(GoOfflineContext);

  if (!value) {
    throw new Error("useGoOffline must be used inside GoOfflineProvider.");
  }

  return value;
}
